import './bistroridge/style';
import FormStructure from './bistroridge/form_structure';

export default FormStructure;